import Sum from './Sum'

export default {
    components: {
        sum: Sum,
    }
}
